/* ==========================================================================
   Inline search — drops a search field under the header with predictive
   product results (Shopify /search/suggest.json). No separate page on open;
   Enter / "view all" still goes to the full results page. No new locale
   strings: labels come from data-* attributes on the panel.
   ========================================================================== */

(function () {
  'use strict';

  function normalizeSearchQuery(query) {
    const normalize = window.EssentialsVault
      && window.EssentialsVault.normalizeSearchQuery;
    return typeof normalize === 'function' ? normalize(query) : query;
  }

  document.querySelectorAll('form[data-search-normalize]').forEach((searchForm) => {
    searchForm.addEventListener('submit', () => {
      const queryInput = searchForm.querySelector('input[name="q"]');
      if (!queryInput) return;

      queryInput.value = normalizeSearchQuery(queryInput.value);
    }, true);
  });

  const panel = document.querySelector('[data-search-panel]');
  if (!panel) return;

  const toggle = document.querySelector('[data-search-toggle]');
  const input = panel.querySelector('[data-search-input]');
  const results = panel.querySelector('[data-search-results]');
  const form = panel.querySelector('form');
  const label = panel.getAttribute('data-search-label') || 'Search';
  const storefrontRoot = () =>
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    || (window.theme && window.theme.routes && window.theme.routes.root)
    || '/';
  let timer = null;
  let lastQuery = '';

  function open() {
    panel.setAttribute('data-open', 'true');
    toggle?.setAttribute('aria-expanded', 'true');
    window.theme.lockScroll('search');
    setTimeout(() => input?.focus(), 50);
  }

  function close() {
    panel.setAttribute('data-open', 'false');
    toggle?.setAttribute('aria-expanded', 'false');
    window.theme.unlockScroll('search');
  }

  function isOpen() {
    return panel.getAttribute('data-open') === 'true';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function renderAllLink(q) {
    const href = `${form.getAttribute('action')}?q=${encodeURIComponent(q)}&type=product`;
    return `<a class="search-panel__all" href="${href}">${escapeHtml(label)}: “${escapeHtml(q)}” →</a>`;
  }

  function render(products, q) {
    if (!products.length) {
      results.innerHTML = renderAllLink(q);
      return;
    }
    const hits = products.map((p) => {
      const img = (p.featured_image && p.featured_image.url) || p.image || '';
      const price = typeof p.price === 'string' ? p.price : '';
      return `
        <a class="search-panel__hit" href="${escapeHtml(p.url)}">
          <span class="search-panel__hit-media">${img ? `<img src="${escapeHtml(img)}" alt="" loading="lazy">` : ''}</span>
          <span class="search-panel__hit-title">${escapeHtml(p.title)}</span>
          <span class="search-panel__hit-price">${escapeHtml(price)}</span>
        </a>`;
    }).join('');
    results.innerHTML = `<div class="search-panel__list">${hits}</div>${renderAllLink(q)}`;
  }

  async function search(q) {
    try {
      const apiQuery = normalizeSearchQuery(q);
      const url = `${storefrontRoot()}search/suggest.json?q=${encodeURIComponent(apiQuery)}`
        + `&resources[type]=product&resources[limit]=6`
        + `&resources[options][unavailable_products]=last`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (q !== lastQuery) return; // a newer query already fired
      render(data?.resources?.results?.products || [], q);
    } catch (err) {
      console.error(err);
    }
  }

  toggle?.addEventListener('click', (e) => {
    e.preventDefault();
    isOpen() ? close() : open();
  });

  panel.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-close]')) {
      if (input) { input.value = ''; }
      results.innerHTML = '';
      lastQuery = '';
      close();
    }
  });

  input?.addEventListener('input', () => {
    const q = input.value.trim();
    lastQuery = q;
    clearTimeout(timer);
    if (q.length < 2) { results.innerHTML = ''; return; }
    timer = setTimeout(() => search(q), 200);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) close();
  });
})();
